export const isDev = (): boolean => process.env.NODE_ENV === 'development';
export const isProd = (): boolean => process.env.NODE_ENV === 'production';

// REACT_APP_TOOL can be one of
// ['JAKHUB', 'JAKHUB-CN', 'MENUS']
// These are set in the build script
// URL management is different in (JAKHUB vs JAKHUB-CN) vs Jakhub's MENUS
export const isJakhub = (): boolean => process?.env?.REACT_APP_TOOL?.substring(0, 6) === 'JAKHUB';
export const isJakhubForChina = (): boolean => process?.env?.REACT_APP_TOOL === 'JAKHUB-CN';
